import { Auth } from "@aws-amplify/auth"
import { createContext, Dispatch, FunctionComponent, SetStateAction, useEffect, useState } from "react"
import { Group } from "../data/models"

interface IAppContext {
	isAuthenticated: boolean
	setIsAuthenticated: Dispatch<SetStateAction<boolean>>
	groups: Group[]
	setGroups: Dispatch<SetStateAction<Group[]>>
}

const AppContext = createContext<IAppContext>({
	isAuthenticated: false,
	setIsAuthenticated: () => {},
	groups: [],
	setGroups: () => {},
})

interface IAppProvider {
	children?: JSX.Element | JSX.Element[]
}

const AppProvider: FunctionComponent<IAppProvider> = ({ children }) => {
	const [isAuthenticated, setIsAuthenticated] = useState(false)
	const [groups, setGroups] = useState<Group[]>([])
	useEffect(() => {
		Auth.currentSession()
			.then((session) => {
				setGroups(session.getIdToken().payload["cognito:groups"])
				setIsAuthenticated(true)
			})
			.catch(() => {
				setGroups([])
				setIsAuthenticated(false)
			})
	}, [setIsAuthenticated])
	const value: IAppContext = {
		isAuthenticated,
		setIsAuthenticated,
		groups,
		setGroups,
	}
	return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}

export { AppContext, AppProvider }
